setVideoPlayerMetaVisible